"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _core = require("@chakra-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Input = function Input(props) {
  var _props$label, _props$help;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (props === null || props === void 0 ? void 0 : (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Text, {
    mb: "8px"
  }, props.label, props.required && /*#__PURE__*/_react["default"].createElement(_core.Text, {
    as: "sup",
    color: "brand.red"
  }, "*"))), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    return /*#__PURE__*/_react["default"].createElement(_core.Input, _extends({
      borderColor: "brand.grey",
      _hover: {
        borderColor: "brand.darkGrey"
      },
      fontSize: "14px",
      _focus: {
        borderColor: "brand.black",
        boxShadow: "0 0 0 1px brand.black"
      },
      mb: props.help ? "5px" : {
        base: "15px",
        md: "30px"
      },
      "aria-label": props.label,
      onChange: function onChange(e) {
        return form.setFieldValue(field.name, e.target.value);
      },
      isDisabled: form.isSubmitting || props.disabled
    }, props));
  }), (props === null || props === void 0 ? void 0 : (_props$help = props.help) === null || _props$help === void 0 ? void 0 : _props$help.length) > 0 && (props === null || props === void 0 ? void 0 : props.type) !== 'hidden' && /*#__PURE__*/_react["default"].createElement(_core.Text, {
    color: "gray.500",
    fontSize: "sm",
    mb: {
      base: "15px",
      md: "30px"
    }
  }, props.help));
};

exports.Input = Input;